export const CSI_DIVISIONS = [
  { number: "00", title: "Exigences relatives aux approvisionnements et aux contrats" },
  { number: "01", title: "Exigences générales" },
  { number: "02", title: "Conditions existantes" },
  { number: "03", title: "Béton" },
  { number: "04", title: "Maçonnerie" },
  { number: "05", title: "Métaux" },
  { number: "06", title: "Bois, plastiques et composites" },
  { number: "07", title: "Isolation thermique et étanchéité" },
  { number: "08", title: "Ouvertures et fermetures" },
  { number: "09", title: "Revêtements de finition" },
  { number: "10", title: "Ouvrages spéciaux" },
  { number: "11", title: "Matériel et équipement" },
  { number: "12", title: "Ameublement et décoration" },
  { number: "13", title: "Installations spéciales" },
  { number: "14", title: "Systèmes transporteurs" },
  { number: "21", title: "Lutte contre les incendies" },
  { number: "22", title: "Plomberie" },
  { number: "23", title: "Chauffage, ventilation et conditionnement d'air" },
  { number: "25", title: "Automatisation intégrée" },
  { number: "26", title: "Électricité" },
  { number: "27", title: "Communications" },
  { number: "31", title: "Terrassements" },
  { number: "32", title: "Aménagements extérieurs" }
];
